import AudioProvider from './AudioProvider';
import HallowAudio from './HallowAudio';
import logo from './images/logo.svg';
import Marquee from './Marquee';
import PlayButton from './PlayButton';
import Scrubber from './Scrubber';
import shareIcon from './images/share.svg';
import ShareSheet from './ShareSheet';
import style from './styles/App.module.scss';
import { useAspectRatioClass } from './hooks/useAspectRatioClass';
import { useIntl } from 'react-intl';
import { useMarquee } from './hooks/useMarquee';
import { ApiPrayer, isApiPrayer } from './models/ApiPrayer';
import { useEffect, useRef, useState } from 'react';
import './styles/App.module.scss';

function App() {
    const titleRef = useRef<HTMLDivElement>(null);
    const descRef = useRef<HTMLDivElement>(null);
    const [content, setContent] = useState<ApiPrayer>(null);
    const [showShare, setShowShare] = useState<boolean>(false);
    const [appRef, aspectRatio] = useAspectRatioClass<HTMLDivElement>();
    const [addChildSize, maxMarqueeSize, resetMarquee] = useMarquee();
    const intl = useIntl();
    
    useEffect(() => {
        const date = new Date;
        const opts = { headers: { 'X-Hallow-Language': intl.locale } };
        fetch(`${ process.env.REACT_APP_API_BASE }/public/daily-gospels/${ date.toISOString().split('T')[0] }`, opts)
            .then((res) => res.json())
            .then((publicPrayer) => {
                if (isApiPrayer(publicPrayer)) setContent(publicPrayer);
            });
    }, []);
    
    if (content === null) return null;
    
    const filenamePieces = content.image_url.split('/');
    const originalFilename = filenamePieces.splice(-1)[0];
    filenamePieces.push(originalFilename.replace(/_\w\.png$/, '_blurred.png'));
    const bgImageUrl = filenamePieces.join('/');
    
    return (<div className={`${ aspectRatio } ${ style.App }`} ref={appRef}>
        <AudioProvider>
            <div className={style.backdrop}>
                <div className={style.backdropImage} style={{ backgroundImage: `url(${ bgImageUrl })` }} />
            </div>
            <div className={style.grid}>
                <img className={style.logo} src={logo} alt={intl.formatMessage({ id: 'app_name', defaultMessage: 'Hallow' })} />
                <button className={style.share} onClick={() => setShowShare(true)}>
                    <img src={shareIcon} alt={intl.formatMessage({ id: 'general_word_share', defaultMessage: 'Share' })} />
                </button>
                <div className={style.sessionWrapper}>
                    <div className={style.session}>
                        <div className={style.mainImage} style={{ backgroundImage: `url(${ content.image_url })` }} />
                        <div className={style.controls}>
                            <h1 ref={titleRef}>
                                <Marquee determinantRef={titleRef} addToManager={addChildSize} maxWidth={maxMarqueeSize} resetManager={resetMarquee} recalculate={aspectRatio}>
                                    {content.title}
                                </Marquee>
                            </h1>
                            <h2 ref={descRef}>
                                <Marquee determinantRef={descRef} addToManager={addChildSize} maxWidth={maxMarqueeSize} resetManager={resetMarquee} recalculate={aspectRatio}>
                                    {content.label_desc}
                                </Marquee>
                            </h2>
                            <HallowAudio audioUrl={content.audio_url} />
                            <PlayButton />
                            <div className={style.sliderWrapper}>
                                <Scrubber />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            { showShare && <ShareSheet close={() => setShowShare(false)} title={content.title} id={content.id} /> }
        </AudioProvider>
    </div>);
}

export default App;